<%= form_with(model: billable, class: "contents") do |form| %>
  <% if billable.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(billable.errors.count, "error") %> prohibited this billable from being saved:</h2>

      <ul class="list-disc ml-6">
        <% billable.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :name %>
    <%= form.text_field :name, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": billable.errors[:name].none?, "border-red-400 focus:outline-red-600": billable.errors[:name].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :type %>
    <%= form.text_field :type, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": billable.errors[:type].none?, "border-red-400 focus:outline-red-600": billable.errors[:type].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :price %>
    <%= form.text_field :price, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": billable.errors[:price].none?, "border-red-400 focus:outline-red-600": billable.errors[:price].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :order %>
    <%= form.number_field :order, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": billable.errors[:order].none?, "border-red-400 focus:outline-red-600": billable.errors[:order].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :table_size %>
    <%= form.number_field :table_size, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": billable.errors[:table_size].none?, "border-red-400 focus:outline-red-600": billable.errors[:table_size].any?}] %>
  </div>

  <div class="my-5 flex items-center gap-2">
    <%= form.label :couples %>
    <%= form.checkbox :couples, class: ["block shadow-sm rounded-md border order-first h-5 w-5", {"border-gray-400 focus:outline-blue-600": billable.errors[:couples].none?, "border-red-400 focus:outline-red-600": billable.errors[:couples].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
